import client from '@libs/HttpClient';
import moment from 'moment';
class AttendanceService {
  //Attendance Master
  static listAttendance(request) {
    const id = '';
    const page_no = request.queryKey[1];
    const searchText = request.queryKey[2];
    const selectedStatus = request.queryKey[3];
    const selectedAdditionalStatus = request.queryKey[4];
    const selectedEmployee = request.queryKey[5];
    const selectedApprover = request.queryKey[6];
    const selectedType = request.queryKey[7];
    const from_date = (request.queryKey[8] != '' && request.queryKey[8] != null) ? moment(request.queryKey[8]).format('DD-MM-YYYY') : '';
    const to_date = (request.queryKey[9] != '' && request.queryKey[9] != null) ? moment(request.queryKey[9]).format('DD-MM-YYYY') : '';
    const selectedFilterTab = (request.queryKey[10] != '' && request.queryKey[10] != null) ? request.queryKey[10] : 'pending';
    const selectedMainTab = (request.queryKey[11] != '' && request.queryKey[11] != null) ? request.queryKey[11] : 'own';
    return client.get(
      `/attendance?search=${searchText}&page=${page_no}&user_id=${id}&selectedStatus=${selectedStatus}&selectedEmployee=${selectedEmployee}&selectedApprover=${selectedApprover}&selectedType=${selectedType}&from_date=${from_date}&to_date=${to_date}&selectedFilterTab=${selectedFilterTab}&selectedMainTab=${selectedMainTab}&selectedAdditionalStatus=${selectedAdditionalStatus}`,
      request
    );
  }
  static addAttendance(request) {
    return client.post(`/attendance`, request);
  }
  static getAttendanceUsers(request) {
    return client.get(`/attendance/user-list`, request);
  }
  static useGetAttendanceTypeList(request) {
    return client.get(`/attendance/type-list`, request);
  }
  static viewAttendance(params) {
    return client.get(`/attendance/${params}/edit`);
  }
  static updateAttendance(request) {
    return client.put(`/attendance/${request.id}`, request);
  }
  static deleteAttendance(request) {
    console.log('request:', request);
    return client.post(`/attendance/cancel/${request.id}`, request);
  }
  static approveOrRejectAttendance(request) {
    return client.post(`/attendance/approve-reject/${request.id}`, request);
  }
  static approverList(request) {
    const get_all = request.queryKey[1] ?? 0;
    return client.get(`/leave-approver-list?all=${get_all}`, request);
  }
  static leaveEmployeeList(request) {
    const get_all = request.queryKey[1] ?? 0;
    return client.get(`/leave-employee-list?all=${get_all}`, request);
  }

  static showAttendance(params) {
    return client.get(`/attendance/${params}`);
  }

}
export { AttendanceService };
